import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, useContext } from '@nuxtjs/composition-api';

interface Props {
    mobile?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Support',
  props: {
    mobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { mobile } = __props as { mobile: boolean };



const context = useContext();

const buttonSize = computed(() => mobile ? 's' : 'l');
const iconSize = computed(() => mobile ? 'xl' : 'big-s');

const chatState = ref(false);
const isLoaded = ref(false);

onMounted(async () => {
    await (context as ReturnType<typeof useContext> & { $zendesk: Promise<Function> }).$zendesk;
    isLoaded.value = true;
    const { zE } = window as (Window & typeof globalThis & {zE: Function});
    zE('messenger:on', 'open', () => {chatState.value = true});
    zE('messenger:on', 'close', () => {chatState.value = false});
});

const toggleMessenger = async () => {
    const { zE } = window as (Window & typeof globalThis & {zE: Function});
    if (chatState.value) {
        zE('messenger', 'close');
    } else {
        zE('messenger', 'open');
    }
};


return { __sfc: true,mobile, context, buttonSize, iconSize, chatState, isLoaded, toggleMessenger }
}

})